import { render, staticRenderFns } from "./ManageInHouse.vue?vue&type=template&id=946fc42a&scoped=true"
import script from "./ManageInHouse.vue?vue&type=script&lang=js"
export * from "./ManageInHouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946fc42a",
  null
  
)

export default component.exports